<template>
    <label
        :class="[
            'inline-flex items-start gap-2 leading-none',
            labelBefore ? 'flex-row-reverse' : '',
            disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
        ]"
    >
        <input
            type="checkbox"
            class="sr-only"
            :checked="isChecked"
            :disabled="disabled"
            @change="onChange"
        />
        <span
            :class="[
                'flex-shrink-0 w-5 h-5 rounded border-2 flex items-center justify-center transition-colors',
                isChecked
                    ? [colorClass, 'border-transparent']
                    : 'bg-theme-input border-theme-disabled'
            ]"
        >
            <check-icon
                class="w-3.5 h-3.5 text-white"
                :class="isChecked ? 'opacity-100' : 'opacity-0'"
            />
        </span>
        <span
            v-if="$slots.default"
            class="text-sm text-theme-base leading-normal"
        >
            <slot></slot>
        </span>
    </label>
</template>

<script>
import CheckIcon from "@/components/icons/CheckIcon.vue";

export default {
    name: "CustomCheckbox",
    components: { CheckIcon },
    props: {
        value: { type: [Boolean, Array], default: false },
        val: { type: [String, Number, Boolean, Object], default: null },
        checked: { type: Boolean, default: null },
        warn: { type: Boolean, default: false },
        success: { type: Boolean, default: false },
        primary: { type: Boolean, default: false },
        danger: { type: Boolean, default: false },
        labelBefore: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false }
    },
    computed: {
        isChecked() {
            if (this.checked !== null) return this.checked;
            if (Array.isArray(this.value)) return this.value.includes(this.val);
            return !!this.value;
        },
        colorClass() {
            if (this.danger) return "bg-theme-danger";
            if (this.warn) return "bg-theme-warning";
            if (this.success) return "bg-theme-success";
            return "bg-theme-primary";
        }
    },
    methods: {
        onChange(evt) {
            if (this.checked === null) {
                if (Array.isArray(this.value)) {
                    const next = [...this.value];
                    const index = next.indexOf(this.val);
                    if (index === -1) next.push(this.val);
                    else next.splice(index, 1);
                    this.$emit("input", next);
                } else {
                    this.$emit("input", !this.value);
                }
            }
            this.$emit("change", evt);
        }
    }
};
</script>
